<template>
    <div class="circle-bg">
        <div class="circle">
            <div class="guide" v-for="rat in get_departments_by_rate" :key="rat._id">
                <div
                    class="square"
                    :class="get_image_or_color(rat.from_rates, 'color')"
                    @click="go_to_comments(rat._id)"
                >
                    <div class="percents">
                        <div class="ants">
                            <div class="ant">
                                <img src="/images/rates/ants/bad.svg" alt="" />
                                <span class="percent">{{ get_count(rat.from_rates, 'low') }}</span>
                            </div>
                            <div class="ant">
                                <img src="/images/rates/ants/good.svg" alt="" />
                                <span class="percent">{{ get_count(rat.from_rates, 'middle') }}</span>
                            </div>
                            <div class="ant">
                                <img src="/images/rates/ants/cool.svg" alt="" />
                                <span class="percent">{{ get_count(rat.from_rates, 'high') }}</span>
                            </div>
                        </div>
                        <div class="department_name">{{ rat.name }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="department_satiscits">
            <div class="name">{{ rate.name }}</div>
            <v-progress-circular :rotate="90" :size="220" :width="16" :value="percent" :color="color">
                <template v-if="color == '#1976d2'"><img src="/images/rates/ants/bad_full.svg" /> </template>
                <template v-else-if="color == 'orange'"><img src="/images/rates/ants/good_full.svg" /></template>
                <template v-else><img src="/images/rates/ants/cool_full.svg" /></template>
            </v-progress-circular>
            <div class="place">{{ get_count_departments }} из {{ get_departments_by_rate.length }}</div>
        </div>
        {{ get_max_color(rate.to_rates) }}
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'OrpList',
    data: () => ({
        color: '',
        percent: 0,
    }),
    components: {},
    computed: {
        ...mapGetters(['get_rate', 'get_departments_by_rate', 'get_count_departments']),
        rate() {
            return this.get_rate()
        },
    },
    beforeMount() {
        if (localStorage.getItem('title') != 'admin' && localStorage.getItem('title') != 'orp')
            this.$router.push('/rates')
        else this.load_departments(this.$route.params.id)
    },
    methods: {
        ...mapActions(['load_departments']),
        get_max_color(rates) {
            if (rates) {
                let rates_array = {}

                const low = rates.filter((rate) => rate.rate == '1')
                const middle = rates.filter((rate) => rate.rate == '2')
                const high = rates.filter((rate) => rate.rate == '3')

                rates_array.low = ((low.length / rates.length) * 100).toFixed()
                rates_array.middle = ((middle.length / rates.length) * 100).toFixed()
                rates_array.high = ((high.length / rates.length) * 100).toFixed()

                const max = Object.keys(rates_array).reduce((a, b) => (rates_array[a] * 1 > rates_array[b] * 1 ? a : b))
                this.percent = rates_array[max]
                switch (max) {
                    case 'low':
                        this.color = '#1976d2'
                        return
                        break
                    case 'middle':
                        this.color = 'orange'

                        return
                        break

                    case 'high':
                        this.color = 'green'
                        return
                        break
                    default:
                        break
                }
            } else {
                return ''
            }
        },
        go_to_comments(_id) {
            this.$router.push({ path: `/rates/${_id}` })
        },
        get_image_or_color(rates, type) {
            if (rates) {
                if (!rates.length && type == 'color') return 'square--yellow'
                let rates_array = {}

                const low = rates.filter((rate) => rate.rate == '1')
                const middle = rates.filter((rate) => rate.rate == '2')
                const high = rates.filter((rate) => rate.rate == '3')

                rates_array.low = ((low.length / rates.length) * 100).toFixed()
                rates_array.middle = ((middle.length / rates.length) * 100).toFixed()
                rates_array.high = ((high.length / rates.length) * 100).toFixed()

                const max = Object.keys(rates_array).reduce((a, b) => (rates_array[a] * 1 > rates_array[b] * 1 ? a : b))

                switch (max) {
                    case 'low':
                        return type == 'image' ? '/images/ants/1-1.png' : 'square--blue'
                        break
                    case 'middle':
                        return type == 'image' ? '/images/ants/3-1.png' : 'square--yellow'
                        break

                    case 'high':
                        return type == 'image' ? '/images/ants/4-1.png' : 'square--green'
                        break
                    default:
                        break
                }
            } else {
                return ''
            }
        },

        get_count(rates, type) {
            if (rates) {
                let x = []
                switch (type) {
                    case 'low':
                        x = rates.filter((rate) => rate.rate == '1')
                        break
                    case 'middle':
                        x = rates.filter((rate) => rate.rate == '2')
                        break
                    case 'high':
                        x = rates.filter((rate) => rate.rate == '3')
                        break

                    default:
                        break
                }

                return x.length
            }
        },
    },
}
</script>


<style scoped>
.circle-bg {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 888px;
    position: relative;
}

.circle-bg .circle {
    position: relative;
}

.department_satiscits {
    text-align: center;
}

.department_satiscits .name {
    font-weight: bold;
    font-size: 32px;
    line-height: 37px;
    color: #000000;
    margin-bottom: 45px;
}

.department_satiscits .place {
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 42px;
    color: #000000;
    margin-top: 10px;
}

.department_satiscits img {
    height: 115px;
}

.guide {
    width: 445px;
    height: 135px;
    transform-origin: 100% 26px;
    transform: rotate(0deg);
    position: absolute;
    top: 0;
    left: -345px;
}

.guide:nth-child(1) {
    transform: rotate(0deg);
    /* margin-left: -220px;
    margin-top: -50px; */
    /* border: 1px solid red; */
    /* margin-left: -90px; */
    margin-left: -108px;
}

.guide:nth-child(2) {
    transform: rotate(18deg);
    /* margin-left: -170px;
    margin-top: -60px; */
    /* margin-left: -67.5px; */
    margin-left: -90px;
}

.guide:nth-child(2) .percents {
    transform: rotate(-18deg);
}

.guide:nth-child(3) {
    transform: rotate(36deg);
    /* margin-left: -115px;
    margin-top: -50px; */
    /* margin-left: -45px; */
    margin-left: -67px;
}
.guide:nth-child(3) .percents {
    transform: rotate(-36deg);
}

.guide:nth-child(4) {
    transform: rotate(54deg);
    /* margin-left: -70px;
    margin-top: -40px; */
    /* margin-left: -22.5px; */
    margin-left: -45px;
}

.guide:nth-child(4) .percents {
    transform: rotate(-54deg);
}

.guide:nth-child(5) {
    transform: rotate(72deg);
    /* margin-left: -35px;
    margin-top: -30px; */
    margin-left: -22px;
}
.guide:nth-child(5) .percents {
    transform: rotate(-72deg);
}

.guide:nth-child(6) {
    transform: rotate(90deg);
    /* margin-left: 0px;
    margin-top: 0px; */
    /* border: 1px solid red; */
    /* margin-left: 7px; */
}

.guide:nth-child(6) .percents {
    transform: rotate(-90deg);
}

.guide:nth-child(7) {
    transform: rotate(108deg);
    /* margin-left: 30px;
    margin-top: 0px; */
    /* margin-top: 27px; */
    margin-left: 22px;
}

.guide:nth-child(7) .percents {
    transform: rotate(-108deg);
}

.guide:nth-child(8) {
    transform: rotate(126deg);
    /* margin-left: 50px;
    margin-top: 15px; */
    /* margin-top: 36px; */
    margin-left: 45px;
}

.guide:nth-child(8) .percents {
    transform: rotate(-126deg);
}

.guide:nth-child(9) {
    transform: rotate(144deg);
    /* margin-left: 80px;
    margin-top: 15px; */
    /* margin-top: 45px; */
    margin-left: 67px;
}

.guide:nth-child(9) .percents {
    transform: rotate(-144deg);
}

.guide:nth-child(10) {
    transform: rotate(162deg);
    /* margin-left: 170px;
    margin-top: 0px; */
    /* margin-top: 68px; */
    margin-left: 90px;
}

.guide:nth-child(10) .percents {
    transform: rotate(-162deg);
}

.guide:nth-child(11) {
    transform: rotate(180deg);
    /* margin-left: 220px;
    margin-top: 0px; */
    /* border: 1px solid red; */
    /* margin-top: 97px; */
    margin-left: 108px;
}

.guide:nth-child(11) .percents {
    transform: rotate(-180deg);
}

.guide:nth-child(12) {
    transform: rotate(198deg);
    /* margin-left: 120px;
    margin-top: 10px; */
    /* margin-top: 112px; */
    /* margin-left: -68px; */
    /* margin-top: 68px;
    margin-left: -22px; */
    margin-left: 90px;
}

.guide:nth-child(12) .percents {
    transform: rotate(-198deg);
}

.guide:nth-child(13) {
    transform: rotate(216deg);
    /* margin-left: 90px;
    margin-top: 15px; */
    /* margin-top: 45px;
    margin-left: -22px; */

    margin-left: 67px;
}

.guide:nth-child(13) .percents {
    transform: rotate(-216deg);
}

.guide:nth-child(14) {
    transform: rotate(234deg);
    /* margin-left: 60px;
    margin-top: 20px; */
    /* margin-top: 22px;
    margin-left: -45px; */

    margin-left: 45px;
}

.guide:nth-child(14) .percents {
    transform: rotate(-234deg);
}

.guide:nth-child(15) {
    transform: rotate(252deg);
    /* margin-left: 30px;
    margin-top: 25px; */
    /* margin-left: -68px;
    margin-top: 22px; */

    margin-left: 22px;
}

.guide:nth-child(15) .percents {
    transform: rotate(-252deg);
}

.guide:nth-child(16) {
    transform: rotate(270deg);
    /* margin-left: 0px;
    margin-top: 0px; */
    /* border: 1px solid red; */
    /* margin-left: -90px; */
}

.guide:nth-child(16) .percents {
    transform: rotate(-270deg);
}

.guide:nth-child(17) {
    transform: rotate(288deg);
    /* margin-left: -30px;
    margin-top: -5px; */
    /* margin-left: -68px; */
    margin-left: -22px;
}

.guide:nth-child(17) .percents {
    transform: rotate(-288deg);
}

.guide:nth-child(18) {
    transform: rotate(306deg);
    /* margin-left: -60px;
    margin-top: -10px; */
    /* margin-left: -68px; */
    margin-left: -45px;
}

.guide:nth-child(18) .percents {
    transform: rotate(-306deg);
}

.guide:nth-child(19) {
    transform: rotate(324deg);
    /* margin-left: -90px;
    margin-top: -15px; */
    /* margin-left: -68px; */
    margin-left: -67px;
}

.guide:nth-child(19) .percents {
    transform: rotate(-324deg);
}

.guide:nth-child(20) {
    transform: rotate(342deg);
    /* margin-left: -120px;
    margin-top: -20px; */
    /* margin-left: -90px; */
    margin-left: -90px;
}

.guide {
    margin: 2px;
}

.guide:nth-child(20) .percents {
    transform: rotate(-342deg);
}

.square {
    width: 150px;
    height: 150px;
    border-radius: 81px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.square .percents .ants {
    display: flex;
}

.square .percents .ants .ant {
    margin-right: 6px;
}

.square .percents .ants .ant img {
    height: 25px;
}

.square .percents .ants .ant span {
    font-weight: bold;
    font-size: 12px;
    line-height: 19px;
    color: #1b1b1b;
}

.square .percents .department_name {
    font-size: 12px;
    text-align: center;
}

.square.square--blue {
    background: #9db6ec;
    border: 1px solid #335499;
}

.square.square--yellow {
    background: #ffe2be;
    border: 1px solid #a6773e;
}

.square.square--green {
    background: #cff1ba;
    border: 1px solid #609d3c;
}
</style>